import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ContentProvider } from "./context/ContentContext";
import { AudioProvider } from "./context/AudioContext";
import GlobalMiniPlayer from "./components/GlobalMiniPlayer";
import PushClickTracker from "./components/PushClickTracker";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import BottomNav from "./components/BottomNav";
import StreakCelebration from "./components/StreakCelebration";
import HomePage from "./pages/HomePage";
import PostDetailPage from "./pages/PostDetailPage";
import CategoryPage from "./pages/CategoryPage";
import ProfilePage from "./pages/ProfilePage";
import FriendProfilePage from "./pages/FriendProfilePage";
import JournalPage from "./pages/JournalPage";
import BreathingExercisesPage from "./pages/BreathingExercisesPage";
import SoundscapesPage from "./pages/SoundscapesPage";
import { ProgramsIndexPage, ProgramDetailPage } from "./pages/ProgramsPages";
import AuthPage from "./pages/AuthPage";
import CommunityPage from "./pages/CommunityPage";
import JourneySharePage from './pages/JourneySharePage';
import JourneyInvitePage from './pages/JourneyInvitePage';
import CirclePage from "./pages/CirclePage";
import ModerationPage from "./pages/ModerationPage";
import NotificationsPage from "./pages/NotificationsPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ManifestPage from "./pages/ManifestPage";
import ManifestThemePage from "./pages/ManifestThemePage";
import AffirmationPage from "./pages/AffirmationPage";
import DailyRedirect from "./pages/DailyRedirect";
import ExplorePage from "./pages/ExplorePage";
import WorkplaceResetPage from "./pages/WorkplaceResetPage";
import WorkplaceBreathPage from "./pages/WorkplaceBreathPage";
import HealingPage from "./pages/HealingPage";
import GriefPage from "./pages/GriefPage";
import MorePage from "./pages/MorePage";
import UniversalSearchPage from "./pages/UniversalSearchPage";
import AdminContentPage from "./pages/AdminContentPage";
import VideosPage from "./pages/VideosPage";
import PersonalizePage from "./pages/PersonalizePage";
import MembershipPage from "./pages/MembershipPage";
import OnboardingFlow from "./components/OnboardingFlow";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ContentProvider>
          <AudioProvider>
            <BrowserRouter>
              <PushClickTracker />
              <div className="app-shell">
                <Header />
                <main className="app-content">
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/today" element={<HomePage />} />
                    <Route path="/post/:id" element={<PostDetailPage />} />
                    <Route path="/category/:categoryId" element={<CategoryPage />} />
                    <Route path="/profile" element={<ProfilePage />} />
                    <Route path="/user/:userId" element={<FriendProfilePage />} />
                    <Route path="/journal" element={<JournalPage />} />
                    <Route path="/breathing" element={<BreathingExercisesPage />} />
                    <Route path="/sounds" element={<SoundscapesPage />} />
                    <Route path="/sounds/:id" element={<SoundscapesPage />} />
                    <Route path="/programs" element={<ProgramsIndexPage />} />
                    <Route path="/programs/:programId" element={<ProgramDetailPage />} />
                    <Route path="/auth" element={<AuthPage />} />
                    <Route path="/community" element={<CommunityPage />} />
                    <Route path="/circles/:circleId" element={<CirclePage />} />
                    <Route path="/journey/:token" element={<JourneySharePage />} />
                    <Route path="/journey-invite/:token" element={<JourneyInvitePage />} />
                    <Route path="/moderation" element={<ModerationPage />} />
                    <Route path="/notifications" element={<NotificationsPage />} />
                    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                    <Route path="/reset-password" element={<ResetPasswordPage />} />
                    <Route path="/manifest" element={<ManifestPage />} />
                    <Route path="/manifest/:themeId" element={<ManifestThemePage />} />
                    <Route path="/a/:themeId/:index" element={<AffirmationPage />} />
                    <Route path="/daily" element={<DailyRedirect />} />
                    <Route path="/explore" element={<ExplorePage />} />
                    <Route path="/workplace-reset" element={<WorkplaceResetPage />} />
                    <Route path="/workplace-reset/:pattern" element={<WorkplaceBreathPage />} />
                    <Route path="/healing" element={<HealingPage />} />
                    <Route path="/grief" element={<GriefPage />} />
                    <Route path="/more" element={<MorePage />} />
                    <Route path="/search" element={<UniversalSearchPage />} />
                    <Route path="/admin/content" element={<AdminContentPage />} />
                    <Route path="/videos" element={<VideosPage />} />
                    <Route path="/personalize" element={<PersonalizePage />} />
                    <Route path="/membership" element={<MembershipPage />} />
                  </Routes>
                </main>
                <GlobalMiniPlayer />
                <BottomNav />
                <StreakCelebration />
                <OnboardingFlow />
              </div>
              <Toaster position="top-right" richColors offset={80} />
            </BrowserRouter>
          </AudioProvider>
        </ContentProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
